import { useTranslation } from 'react-i18next';
import { useData } from './useData';

export interface ApiError extends Error {
    statusCode: number;
    errors: any; // validation errors
}

export const useApiConfig = () => {
    const { i18n } = useTranslation();
    const { login, setLogin } = useData();

    // will send headers across all api requests
    const getHeaders = () => {
        const headers: HeadersInit = { 'Content-Type': 'application/json' };

        if (login?.data?.token) {
            headers.Authorization = `Bearer ${login.data.token}`;
        }

        return headers;
    };

    // will send language across all api requests
    const getCommonParameters = () => {
        return { language: i18n.language };
    };

    const handleCommonErrors = (error: ApiError) => {
        // 401:
        // - either token is invalid/expired
        // - or user inserted wrong credentials at login
        if (error.statusCode === 401) {
            // force logout
            login !== null && setLogin(null);
        }
    };

    return {
        getHeaders,
        getCommonParameters,
        handleCommonErrors,
    };

};
export const getHeaders = (token?: string): HeadersInit => {
    const headers: HeadersInit = { 'Content-Type': 'application/json' };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return headers;
};

